import React from 'react';
import Canais from '../../components/Paginas/Canais/Canais';

const CanaisPage = () => {
  return ( <Canais/> );
}
 
export default CanaisPage;